import {customElement, query} from "lit/decorators.js";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";

@customElement("eop-inline-modal-dialog-content-link")
export class EopInlineModalDialogContentLink extends DialogAnchorTemplateContent {

    @query(".label")
    private labelElement: HTMLElement;

    public connectedCallback(): void {
        super.connectedCallback();
        this.labelElement.addEventListener("click", (e: Event) => {
            this.openDialog(e);
        });
    }
}